import React from 'react'
import { ReactComponent as GateSoftSvg} from '../../assets/svgs/clients/GateSoft.svg';

const GateSoftLogo = () => (
    <div>
        <GateSoftSvg/>
    </div>
)

export default GateSoftLogo